import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { SECTIONS } from "../PlayerSection/PlayerSection";
import { IMG } from "../../Commons/Functions";

function HiddenSectionModal(props) {
    const sectionName = props.section === SECTIONS.DISCARD ? "Discard" : "Removed"
    return (
        <Modal className="fullscreen-modal modal-game-panel" show={props.show} onHide={props.handleClose} centered>
            <Modal.Header>
                <Modal.Title>{sectionName}</Modal.Title>
                <Button variant="primary" className="ms-auto" onClick={props.handleClose}>
                    Close
                </Button>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    {[...props.cards]
                        .filter(card => card.position.section === props.section)
                        .map(card => (
                            <Col xs={3} key={card.id}>
                                <OpponentCard card={card} onClick={() => {
                                    props.sendToHistory("Pinged from " + sectionName.toLowerCase(), card)
                                }} />
                            </Col>
                        ))}
                </Row>
            </Modal.Body>
        </Modal>
    )
}

function areEqual(prevProps, nextProps) {
    return prevProps.refreshCount === nextProps.refreshCount &&
        prevProps.show === nextProps.show
}

export default React.memo(HiddenSectionModal, areEqual)

function OpponentCard(props) {
    const [isClicked, setIsClicked] = useState(false);

    useEffect(() => {
        if (isClicked) {
            setTimeout(() => {
                setIsClicked(false)
            }, 400)
        }
    }, [isClicked]);

    const handleClick = () => setIsClicked(true);

    return (
        <div className={"modal-panel-card w-100 h-100 position-relative d-flex flex-column justify-content-between clickable-panel-card" + (isClicked ? " clicked" : "")}>
            <div className="wrapper">
                <IMG src={props.card.cardData.face.front.image} className='w-100 h-100 no-drag' />
                <div className="box-container opacity-0 position-absolute w-100 h-100 top-0 start-0" onClick={() => {
                    props.onClick()
                    if (!isClicked) {
                        handleClick()
                    }
                }}>
                    <h1 className="no-drag">{isClicked ? "Pinged !" : "Ping"}</h1>
                </div>
            </div>
        </div>
    )
}